import { Chip } from "@mui/material";
import { api } from "../services/api";
import { useApiData } from "../hooks/useApiData";
import { useSession } from "../context/SessionContext";
import { DataState } from "../components/Feedback";
import PageHeader from "../components/PageHeader";
import SectionCard from "../components/SectionCard";
import DataTable, { TwoLine } from "../components/DataTable";
import StatusChip from "../components/StatusChip";
import { TIER } from "../constants";
import { formatDate } from "../utils/format";

export default function VendorsPage() {
  const { clientId } = useSession();
  const state = useApiData(() => api.getVendors(), [clientId]);

  const columns = [
    { key: "name", label: "Vendor", render: (v) => <TwoLine main={v.name} sub={v.service} /> },
    {
      key: "riskTier", label: "Risk tier",
      render: (v) => <StatusChip label={v.riskTierLabel} color={TIER[v.riskTier || "UNASSIGNED"].color} />,
    },
    {
      key: "hasAiComponents", label: "AI in product",
      render: (v) => (v.hasAiComponents ? <Chip size="small" color="secondary" label="Uses AI" /> : "—"),
    },
    { key: "lastAssessedOn", label: "Last assessed", render: (v) => formatDate(v.lastAssessedOn) },
    { key: "contractEnd", label: "Contract ends", render: (v) => formatDate(v.contractEnd) },
  ];

  return (
    <>
      <PageHeader title="Vendors" subtitle="Third parties we depend on, with a note where they use AI inside their product." />
      <DataState state={state}>
        {(rows) => (
          <SectionCard>
            <DataTable columns={columns} rows={rows} emptyText="No vendors yet." />
          </SectionCard>
        )}
      </DataState>
    </>
  );
}
